import axios from 'axios';
import { toast } from 'react-toastify';
import {
  APP_SETTING_ADD_NOTIFICATION_SETTING_BEGIN,
  APP_SETTING_ADD_NOTIFICATION_SETTING_SUCCESS,
  APP_SETTING_ADD_NOTIFICATION_SETTING_FAILURE,
  APP_SETTING_ADD_NOTIFICATION_SETTING_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
export function addNotificationSetting(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_ADD_NOTIFICATION_SETTING_BEGIN,
    });
    const { projectId, version, data } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const URL = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/notification-setting`;
      const doRequest = axios.post(URL, data, header);
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_ADD_NOTIFICATION_SETTING_SUCCESS,
              data: res.data,
            });
            toast.success('Created Successfully !', {});
            resolve(res.data);
          } else {
            dispatch({
              type: APP_SETTING_ADD_NOTIFICATION_SETTING_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_ADD_NOTIFICATION_SETTING_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}` || 'Creation Failed !');
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddNotificationSettingError() {
  return {
    type: APP_SETTING_ADD_NOTIFICATION_SETTING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_ADD_NOTIFICATION_SETTING_BEGIN:
      return {
        ...state,
        addNotificationSettingPending: true,
        addNotificationSettingError: null,
      };

    case APP_SETTING_ADD_NOTIFICATION_SETTING_SUCCESS:
      return {
        ...state,
        addNotificationSettingPending: false,
        addNotificationSettingError: null,
        projectDetail: action.data ? action.data : state.projectDetail,
      };

    case APP_SETTING_ADD_NOTIFICATION_SETTING_FAILURE:
      return {
        ...state,
        addNotificationSettingPending: false,
        addNotificationSettingError: action.data.error,
      };

    case APP_SETTING_ADD_NOTIFICATION_SETTING_DISMISS_ERROR:
      return {
        ...state,
        addNotificationSettingError: null,
      };

    default:
      return state;
  }
}
